import React from 'react'
import images from '../assets/img'
import { logoImage } from '../api'
import { VERSION } from '../assets/const';

export default ({ periods }) => {
  const period = periods.list.filter(
    a => a.xp_Key === periods.currentVisiblePeriod
  )[0];

  let periodName = '';
  let startTime = '';
  let stopTime = '';
  let eatGroupName = '';
  if (period) {
    periodName = period.Name
    startTime = period.Start.toFormat('H:mm')
    stopTime = period.Stop.toFormat('H:mm')
    eatGroupName = period.eatGroupNmae
  }

  return (
    <header>
      <div className="header-left">
        <img src={images.lmslogo} alt="LMS школа" />
        {period && (
          <div className="headline-wrapper">
            <div>{eatGroupName}</div>
            <div>
              {periodName} {startTime} - {stopTime}
            </div>
          </div>
        )}
      </div>
      <div className="logo-right">
        <img src={logoImage} alt="Logo" />
      </div>
      <div className='version'>{VERSION}</div>
    </header>
  )
}
